import { useCallback } from 'react';
import { getPageNavigation } from './getPageNavigation';
export var usePageNavigation = function usePageNavigation(_ref) {
  var pageNumber = _ref.pageNumber,
      pageSize = _ref.pageSize,
      itemCount = _ref.itemCount,
      displayRange = _ref.displayRange,
      onPageSelect = _ref.onPageSelect,
      enablePageSizeSelector = _ref.enablePageSizeSelector,
      onPageSizeChange = _ref.onPageSizeChange,
      pageSizeList = _ref.pageSizeList;
  var onPageButtonClick = useCallback(function (event) {
    if (!onPageSelect) {
      return;
    }

    var button = event.currentTarget;
    var buttonDisabled = !!button.getAttribute('data-disabled');

    if (buttonDisabled) {
      return;
    }

    var currentPageNumber = button.getAttribute('data-pagenumber');

    if (currentPageNumber !== null) {
      var currentPageNumberSafe = parseInt(currentPageNumber, 10);

      if (!Number.isNaN(currentPageNumberSafe)) {
        onPageSelect(currentPageNumberSafe);
      }
    }
  }, [onPageSelect]);
  var onPageSelectorChange = useCallback(function (event) {
    if (onPageSizeChange) {
      onPageSizeChange(event.target.value);
    }
  }, [onPageSizeChange]);
  return {
    pageSizeSelectorProps: {
      options: pageSizeList,
      onChange: onPageSelectorChange,
      value: pageSize
    },
    structure: getPageNavigation(itemCount, pageNumber, pageSize, displayRange),
    onPageButtonClick: onPageButtonClick,
    enablePageSizeSelector: enablePageSizeSelector
  };
};